<template>
  <v-layout wrap>
    <v-flex xs12 md8 lg9>
      <v-card class="pa-4">
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
}
</script>
